import React, { useEffect, useState } from "react";
import { Grid, IconButton, Tooltip } from "@material-ui/core";
import {
  BackButton,
  ButtonSubmit,
  Container,
  MTable,
  Panel,
  DeleteAlert,
  Pagination,
  PaginationTable,
} from "../../../../Components";
import { useStyles } from "./Customer.styles";
import {
  PasswordField,
  TextField2,
  NumberField,
} from "../../../../Components/Field";
import { useLocation, useNavigate } from "react-router-dom";
import { useIntl } from "react-intl";
import { useDispatch, useSelector } from "react-redux";
import CustomerServicesApi from "../../../../Redux/Actions/CustomerAction";
import { useSnackbar } from "notistack";
import CopyIcon from "../../../../Assets/Images/copyIcon.png";
import { inputFieldProps } from "./FormProps";
import { Alert, AlertTitle } from "@mui/material";
import { ExistingUser } from "./ExistingUser";
import { RoleProps } from "../../../../Components/Field";
import { getAppConfiguration } from "../../../../Config";
export const UpdateFormCustomer = () => {
  let {
    userList,
    apiToken,
    infoUpdateCustomer,
    getCustomersById,
    currentUser,
  } = useSelector((state: any) => ({
    userList: state?.UserReducer?.userList,
    apiToken: state?.UserReducer?.apiToken,
    infoUpdateCustomer: state?.CustomerReducer?.infoUpdateCustomer,
    getCustomersById: state?.CustomerReducer?.getCustomersById,
    currentUser: state?.UserReducer?.currentUser,
  }));
  const customerIdParam = useLocation()?.pathname?.slice(28);
  const classes = useStyles();
  const navigate = useNavigate();
  const { formatMessage } = useIntl();
  const { enqueueSnackbar } = useSnackbar();
  let users = getCustomersById;
  let [input, setInput] = React.useState<inputFieldProps>({
    companyName: "",
    organisation_id: "",
    contactPerson: "",
    visitingAddress: "",
    city: "",
    postalCode: "",
    billingAddress: "",
    billingEmail: "",
    billingCity: "",
    billingPostal: "",
    bilingMobile: "",
    billingReference: "",
    firstName: "",
    lastName: "",
    email: "",
    language: "Swidesh",
    ftp_Name: "",
    ftp_password: "",
  });

  const [coped, setCoped] = React.useState(false);
  const [hover, sethover] = React.useState(false);
  const [reloadPage, setReload] = useState(false);
  let [alertDeleteOpen, setAlertDeleteOpen] = useState<any>(false);
  let [getDeleteCustomer, setGetDeleteCustomer] = useState<any>(null);
  let [addAdmin, setAddAdmin] = useState("");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(50);
  const dispatch: any = useDispatch();
  const [ftpurl, setftpurl] = useState('')
  useEffect(() => {
    if (userList == undefined) {
      navigate("/");
    }
    let updatedata = {
      companyName: getCustomersById?.companyName,
      organisation_id: getCustomersById?.organisationId,
      contactPerson: getCustomersById?.contactPerson,
      visitingAddress:
        getCustomersById?.addresses[0]?.locationAddress != undefined
          ? getCustomersById?.addresses[0]?.locationAddress
          : "",
      city:
        getCustomersById?.addresses[0]?.city != undefined
          ? getCustomersById?.addresses[0]?.city
          : "",
      postalCode:
        getCustomersById?.addresses[0]?.postalCode != undefined
          ? getCustomersById?.addresses[0]?.postalCode
          : "",
      billingAddress:
        getCustomersById?.addresses[1]?.locationAddress != undefined
          ? getCustomersById?.addresses[1]?.locationAddress
          : "",
      billingEmail:
        getCustomersById?.addresses[1]?.email != undefined
          ? getCustomersById?.addresses[1]?.email
          : "",
      billingCity:
        getCustomersById?.addresses[1]?.city != undefined
          ? getCustomersById?.addresses[1]?.city
          : "",
      billingPostal:
        getCustomersById?.addresses[1]?.postalCode != undefined
          ? getCustomersById?.addresses[1]?.postalCode
          : "",
      bilingMobile:
        getCustomersById?.addresses[1]?.mobile != undefined
          ? getCustomersById?.addresses[1]?.mobile
          : "",
      billingReference:
        getCustomersById?.addresses[1]?.referencePerson != undefined
          ? getCustomersById?.addresses[1]?.referencePerson
          : "",
      ftp_Name: getCustomersById?.ftpUserName,
      ftp_password: getCustomersById?.ftpPassword,
      firstName: "",
      lastName: "",
      email: "",
      language: "",
    };
    setInput(updatedata);
  }, []);
  const updateCustomer = () => {
    const updateClientAdmin = {
      companyName: input?.companyName,
      organisationId: input?.organisation_id,
      contactPerson: input?.contactPerson,
      ftpUserName: getCustomersById?.ftpUserName,
      ftpPassword: input?.ftp_password,
      ftpDirectory: getCustomersById?.ftpDirectory,
      addresses: [
        {
          id: getCustomersById?.addresses[0]?.id,
          customerId: customerIdParam,
          locationAddress: input?.visitingAddress,
          city: input?.city,
          postalCode: input?.postalCode,
          email: getCustomersById?.addresses[0]?.email,
          mobile: getCustomersById?.addresses[0]?.mobile,
          addressType: getCustomersById?.addresses[0]?.addressType,
          referencePerson: "",
        },
        {
          id: getCustomersById?.addresses[1]?.id,
          customerId: customerIdParam,
          locationAddress: input?.billingAddress,
          city: input?.billingCity,
          postalCode: input?.billingPostal,
          email: input?.billingEmail,
          mobile: input?.bilingMobile,
          addressType: getCustomersById?.addresses[1]?.addressType,
          referencePerson: input?.billingReference,
        },
      ],
    };
    let customerId = getCustomersById?.id;
    dispatch(
      CustomerServicesApi?.updateInfoCustomer(
        updateClientAdmin,
        customerId,
        apiToken,
        enqueueSnackbar
      )
    );
    if (infoUpdateCustomer) {
      dispatch(CustomerServicesApi?.customers(apiToken));
      navigate("/administration/customers");
    }
  };
  const copyPassword = () => {
    navigator.clipboard.writeText(users?.ftpPassword);
    setCoped(true);
    const timeId = setTimeout(() => {
      setCoped(false);
    }, 2000);
    return () => {
      clearTimeout(timeId);
    };
  };
  const bodydata: any = [
    {
      title: formatMessage({
        id: "document.group.table.name",
        defaultMessage: "First name",
      }),
      field: "firstName",
    },
    {
      title: formatMessage({
        id: "users.table.email",
        defaultMessage: "Email",
      }),
      field: "email",
    },
    {
      title: formatMessage({ id: "users.table.role", defaultMessage: "Role" }),
      field: "role",
      lookup: {
        Admin: formatMessage({
          id: "form.roll.Admin",
          defaultMessage: "Admin",
        }),
        ClientAdmin: formatMessage({
          id: "form.roll.clientAdmin",
          defaultMessage: "ClientAdmin",
        }),
        User: formatMessage({ id: "form.user", defaultMessage: "User" }),
      },
    },
    {
      title: formatMessage({
        id: "users.table.status",
        defaultMessage: "Status",
      }),
      field: "status",
      lookup: {
        Active: formatMessage({
          id: "status.active",
          defaultMessage: "Active",
        }),
        Pending: formatMessage({
          id: "status.pending",
          defaultMessage: "Pending",
        }),
        Expired: formatMessage({
          id: "status.expire",
          defaultMessage: "Expired",
        }),
      },
    },
  ];
  const deleteClient = (user: any) => {
    return {
      tooltip: formatMessage({
        id: "component.mtable.deleteTooltip",
        defaultMessage: "delete",
      }),
      disabled: user?.status == "Active" ? false : true,
      icon: "delete",
      onClick: () => {
        setAlertDeleteOpen(true);
        setGetDeleteCustomer(user);
      },
    };
  };
  const resendInvitation = (user: any) => {
    return {
      tooltip: formatMessage({
        id: "organization.users.table.action.resendInvite",
      }),
      icon: "send",
      disabled: user?.status != "Active" ? false : true,
      onClick: () => {
        let param = {
          email: user?.email,
          firstName: user?.firstName,
          lastName: user?.lastName,
          language: user?.language,
          roleId: RoleProps[user?.role],
          sentBy: currentUser?.id,
          customerId: getCustomersById?.id,
        };
        setReload(true);
        dispatch(
          CustomerServicesApi.sendClientAdminInvitation(
            param,
            apiToken,
            enqueueSnackbar
          )
        );
        setTimeout(() => {
          dispatch(
            CustomerServicesApi.getCustomerById(getCustomersById?.id, apiToken)
          );
          setReload(false);
        }, 1500);
      },
    };
  };
  const deleteClientAdmin = () => {
    let userId = getDeleteCustomer?.id;
    setReload(true);
    dispatch(
      CustomerServicesApi.deleteHardPermissionUser(
        userId,
        apiToken,
        enqueueSnackbar
      )
    );
    setTimeout(() => {
      dispatch(CustomerServicesApi.getCustomerById(customerIdParam, apiToken));
      setReload(false);
      setAlertDeleteOpen(false);
    }, 1000);
  };
  const { pagination, toolbar, body, header } = Pagination();
  useEffect(() => {
    const appConfig = getAppConfiguration()
    setftpurl(appConfig?.ftpurl)
  }, [])
  return (
    <div className="updateFormCustomer-page-container">
      <Container fullWidth>
        <Grid container justifyContent="flex-start">
          <BackButton link={"/administration/customers"} />
        </Grid>
        <Panel titleKey={"admin.users.invite.editCustomer"}>
          <Grid style={{ marginBottom: 10, fontSize: 16, fontWeight: "bold" }}>
            {formatMessage({
              id: "form.information",
              defaultMessage: "Information",
            })}
          </Grid>
          <Grid container spacing={3}>
            <Grid item xs={4}>
              <TextField2
                onChange={(str: string) =>
                  setInput({ ...input, companyName: str })
                }
                placeholder={formatMessage({
                  id: "form.company.input",
                  defaultMessage: "Name",
                })}
                value={input?.companyName}
                Textlabel="form.company.name"
              />
            </Grid>
            <Grid item xs={4}>
              <TextField2
                onChange={(str: string) =>
                  setInput({ ...input, organisation_id: str })
                }
                placeholder={formatMessage({
                  id: "form.organization.input",
                  defaultMessage: "Organisation Id",
                })}
                value={input?.organisation_id}
                Textlabel="form.organization.number"
              />
            </Grid>
            <Grid item xs={4}>
              <TextField2
                onChange={(str: string) =>
                  setInput({ ...input, contactPerson: str })
                }
                placeholder={formatMessage({
                  id: "form.contact.input",
                  defaultMessage: "Contact person",
                })}
                value={input?.contactPerson}
                Textlabel="form.contact.person"
              />
            </Grid>
          </Grid>
          <Grid container spacing={3}>
            <Grid item xs={4}>
              <TextField2
                onChange={(str: string) =>
                  setInput({ ...input, visitingAddress: str })
                }
                placeholder={formatMessage({
                  id: "form.address.input",
                  defaultMessage: "Address",
                })}
                value={input?.visitingAddress}
                Textlabel="form.visiting.address"
              />
            </Grid>
            <Grid item xs={4}>
              <TextField2
                onChange={(str: string) =>
                  setInput({ ...input, postalCode: str })
                }
                placeholder={formatMessage({
                  id: "form.postal.input",
                  defaultMessage: "Postal code",
                })}
                value={input?.postalCode}
                Textlabel="form.postal.code"
              />
            </Grid>
            <Grid item xs={4}>
              <TextField2
                onChange={(str: string) => setInput({ ...input, city: str })}
                placeholder={formatMessage({
                  id: "form.city.input",
                  defaultMessage: "City",
                })}
                value={input?.city}
                Textlabel="form.city"
              />
            </Grid>
          </Grid>
          <Grid
            style={{
              marginTop: 15,
              marginBottom: 10,
              fontSize: 16,
              fontWeight: "bold",
            }}
          >
            {formatMessage({ id: "form.billing", defaultMessage: "Billing" })}
          </Grid>
          <Grid container spacing={3}>
            <Grid item xs={4}>
              <TextField2
                onChange={(str: string) =>
                  setInput({ ...input, billingAddress: str })
                }
                placeholder={formatMessage({
                  id: "form.address.input",
                  defaultMessage: "Billing address",
                })}
                value={input?.billingAddress}
                Textlabel="form.billing.address"
              />
            </Grid>
            <Grid item xs={4}>
              <TextField2
                onChange={(str: string) =>
                  setInput({ ...input, billingEmail: str })
                }
                placeholder={formatMessage({
                  id: "form.email.input",
                  defaultMessage: "Billing email",
                })}
                value={input?.billingEmail}
                Textlabel="form.billing.email"
              />
            </Grid>
            <Grid item xs={4}>
              <TextField2
                onChange={(str: string) =>
                  setInput({ ...input, billingPostal: str })
                }
                placeholder={formatMessage({
                  id: "form.postal.input",
                  defaultMessage: "Postal code",
                })}
                value={input?.billingPostal}
                Textlabel="form.postal.code"
              />
            </Grid>
          </Grid>
          <Grid container spacing={3}>
            <Grid item xs={4}>
              <TextField2
                onChange={(str: string) =>
                  setInput({ ...input, billingCity: str })
                }
                placeholder={formatMessage({
                  id: "form.city.input",
                  defaultMessage: "City",
                })}
                value={input?.billingCity}
                Textlabel="form.city"
              />
            </Grid>
            <Grid item xs={4}>
              <TextField2
                onChange={(str: string) =>
                  setInput({ ...input, billingReference: str })
                }
                placeholder={formatMessage({
                  id: "form.contact.input",
                  defaultMessage: "Reference person",
                })}
                value={input?.billingReference}
                Textlabel="form.reference.person"
              />
            </Grid>
            <Grid item xs={4}>
              <TextField2
                // name={input?.bilingMobile}
                onChange={(str: string) => {
                  if (str?.length <= 10) {
                    setInput({ ...input, bilingMobile: str })
                  }
                }
                }
                placeholder={formatMessage({
                  id: "form.fillInPhoneNumber",
                  defaultMessage: "Mobile Number",
                })}
                value={input?.bilingMobile}
                Textlabel="customer.create.mobile"
              />
            </Grid>
          </Grid>
          {/* Ftp details */}
          <Grid style={{ marginTop: 15, fontSize: 18, fontWeight: "bold" }}>
            {formatMessage({
              id: "admin.users.invite.ftp.details.customer",
              defaultMessage: "FTP Details",
            })}
          </Grid>
          <Grid container>
            <label className={classes.ftpName}>FTP &nbsp;&nbsp;&nbsp;: </label>
            <label className={classes.ftpUrl}>
              {`ftp://${ftpurl}`}
            </label>
            <label className={classes.ftpPort}>
              {formatMessage({ id: "form.port", defaultMessage: "Port" })} :
            </label>{" "}
            <label className={classes.ftpUrl}>21</label>
          </Grid>
          <Grid container>
            <label className={classes.ftpName}>SFTP &nbsp;: </label>
            <label className={classes.ftpUrl}>
              {`sftp://${ftpurl}`}
            </label>
            <label className={classes.sftpPort}>
              {formatMessage({ id: "form.port", defaultMessage: "Port" })}:
            </label>{" "}
            <label className={classes.ftpUrl}>22</label>
          </Grid>
          <Grid container spacing={3} className={classes.margin10}>
            <Grid item xs={4}>
              <TextField2
                onChange={(str: string) =>
                  setInput({ ...input, ftp_Name: str })
                }
                placeholder={formatMessage({
                  id: "customer.create.ftpUser",
                  defaultMessage: "FTP User",
                })}
                value={input?.ftp_Name}
                Textlabel="form.stp.user"
                disabled={users?.id ? true : false}
              />
            </Grid>
            <Grid item xs={4}>
              <PasswordField
                placeholder={formatMessage({
                  id: "customer.create.password",
                  defaultMessage: "FTP Password",
                })}
                handleChange={(str: string) =>
                  setInput({ ...input, ftp_password: str })
                }
                value={input?.ftp_password}
                Textlabel="form.stp.password"
                // disabled={users?.id ? true : false}
                disabled={false}
              />
            </Grid>
            <Grid item xs={1}>
              <Tooltip
                title={formatMessage({
                  id: "form.input.text.copy",
                  defaultMessage: "Copy",
                })}
                aria-label="add"
              >
                <IconButton
                  onClick={copyPassword}
                  className={classes.copyButton}
                  onMouseOver={() => sethover(true)}
                  onMouseOut={() => sethover(false)}
                >
                  <img
                    src={CopyIcon}
                    alt="copyIcon"
                    className={classes.copyImage}
                  />
                </IconButton>
              </Tooltip>
            </Grid>
            <Grid>
              {coped ? (
                <Alert severity="success" className={classes.alertToast}>
                  <AlertTitle>
                    {formatMessage({
                      id: "customer.tost.copy",
                      defaultMessage: "Coped!",
                    })}
                  </AlertTitle>
                </Alert>
              ) : null}
            </Grid>
          </Grid>
          <Grid
            style={{
              marginTop: 15,
              marginBottom: 10,
              fontSize: 16,
              fontWeight: "bold",
            }}
          >
            {formatMessage({
              id: "form.clientAdmin",
              defaultMessage: "Client Admin",
            })}
          </Grid>
          {getCustomersById?.users?.filter(
            (user: any) => user?.role === "ClientAdmin"
          )?.length ? (
            <MTable
              hideToolbar
              columns={bodydata}
              onPageChange={(page) => setPage(page)}
              onRowsPerPageChange={(pageSize: any) =>
                setRowsPerPage(parseInt(pageSize, 10))
              }
              data={getCustomersById?.users?.filter(
                (user: any) => user?.role === "ClientAdmin"
              )}
              isLoading={reloadPage}
              actions={[deleteClient, resendInvitation]}
              localization={{ pagination, toolbar, body, header }}
              components={{
                Pagination: (props: any) => (
                  <Grid component="td" container>
                    <Grid item xs={4}></Grid>
                    <Grid item xs={8}>
                      <PaginationTable
                        props={props}
                        page={page}
                        rowsPerPage={rowsPerPage}
                        count={getCustomersById?.users?.filter(
                          (user: any) => user?.role === "ClientAdmin"
                        )}
                      />
                    </Grid>
                  </Grid>
                ),
              }}
            />
          ) : (
            <Grid container spacing={2}>
              <Grid item>
                <ButtonSubmit
                  text={"group.user.newInvite"}
                  onClick={() => setAddAdmin("New Invite")}
                />
              </Grid>
              <Grid item>
                <ButtonSubmit
                  text={"group.user.existingUser"}
                  onClick={() => setAddAdmin("Existing User")}
                />
              </Grid>
            </Grid>
          )}
          <Grid
            container
            justifyContent="flex-end"
            className={classes.paddingRight40}
          >
            <ButtonSubmit text={"model.title.save"} onClick={updateCustomer} />
          </Grid>
        </Panel>
        <DeleteAlert
          alertClose={() => setAlertDeleteOpen(false)}
          alertOpen={alertDeleteOpen}
          componentName={"form.clientAdmin"}
          Submited={deleteClientAdmin}
          deletedValue={getDeleteCustomer?.firstName}
        />
        {addAdmin !== "" && (
          <ExistingUser openpopup={addAdmin} onclose={() => setAddAdmin("")} />
        )}
      </Container>
    </div>
  );
};
